import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import List from '../views/List.vue'
import Campaign from '../views/Campaign.vue'
import CampaignDm from '../views/CampaignDm.vue'
import CampaignPlayer from '../views/CampaignPlayer.vue'
import Login from '../views/Login.vue'
import SignUp from '../views/SignUp.vue'

Vue.use(VueRouter)

let router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/campaigns'
    },
    {
      path: '/campaigns',
      name: 'campaigns',
      props: false,
      component: List,
      meta: {
        requiresAuth: true,
        showBackButton: false,
        title: 'All Campaigns | Thwack Tracker',
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        title: 'Log In | Thwack Tracker',
      },
    },
    {
      path: '/signup',
      name: 'signup',
      component: SignUp,
      meta: {
        title: 'Sign Up | Thwack Tracker',
      },
    },
    {
      path: '/campaigns/:slug', 
      name: 'campaign',
      component: Campaign,
      // props: true,
      children: [
        {
          path: 'player',
          name: 'campaignPlayer',
          component: CampaignPlayer,
          props: true,
          meta: {
            requiresAuth: true,
            showBackButton: true,
            title: 'Player | Thwack Tracker',
          },
        },
        {
          path: 'dm',
          name: 'campaignDm',
          component: CampaignDm,
          props: true,
          meta: {
            requiresAuth: true,
            showBackButton: true,
            title: 'DM | Thwack Tracker',
          },
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  // check for authentication
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.state.user) {
      next({
        path: '/login',
        query: { redirect: '/campaigns' }
      })
    } else {
      next()
    }
  } else {
    next()
  }
  // update page title
  if (to.params.id) {
    document.title = `${to.params.name} ${to.meta.title}`
  } else {
    document.title = to.meta.title
  }
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js